import { MUSIC_ACCESS_FLOW_VISUAL_RECIPE } from "@libs/shared-ui";
import { theme } from "@theme";
import { getViewPort } from "@utils/web/config";
import { Dimensions, useWindowDimensions } from "react-native";

export const { width, height } = Dimensions.get("window");

export const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = getViewPort({
  width,
  height,
});
/**
 * The access screens' viewport, read on every render. `SCREEN_WIDTH` and
 * `SCREEN_HEIGHT` are read once, at import: a page that loaded with no height
 * (seen 1 Oct on web, in a preview pane loaded while hidden; an in-app
 * browser's first layout can do the same) keeps 0 for the whole session, and
 * an access page laid out with it showed only its gradient. Size layouts with
 * this instead.
 */
export const useAccessViewport = () => getViewPort(useWindowDimensions());

export const BUTTON_SPACING = theme.spacing.s2;
export const FOUR_BUTTON_LAYOUT_BUTTON_WIDTH =
  (SCREEN_WIDTH - theme.spacing.s4 * 2 - BUTTON_SPACING * 3) / 4;
export const THREE_BUTTON_LAYOUT_BUTTON_WIDTH =
  (SCREEN_WIDTH - theme.spacing.s4 * 2 - BUTTON_SPACING * 2) / 3;
export const BUTTON_HEIGHT = FOUR_BUTTON_LAYOUT_BUTTON_WIDTH * 0.65;
export const PREVIEW_DURATION_IN_SECONDS = 10;

export const LOADING_SHIMMER_SPEED = 1200;
export const LOADING_SHIMMER_BG_COLOR = theme.colors.whiteTranslucent20;
export const LOADING_SHIMMER_HIGHLIGHT_COLOR = theme.colors.whiteTranslucent50;

// All access screens (music and concerts) share the music-access recipe
// gradient so LIB and mobile stay aligned (LIS-985).
export const DEFAULT_BACKGROUND_STOPS =
  MUSIC_ACCESS_FLOW_VISUAL_RECIPE.backgroundStops;
